// extracted by mini-css-extract-plugin
export default {"container":"style_container__yucIS","header":"style_header__HWftw","status":"style_status__CaGJi","message":"style_message__eTojT"};